import * as React from 'react';
// import Lottie from 'react-lottie';
import { Animes } from './animes';

// 動的インポートで`react-lottie`をクライアントサイド限定で読み込み
const Lottie =
  typeof window !== 'undefined' ? require('react-lottie').default : null;

type Props = {
  type: keyof typeof Animes;
  width?: string;
  height?: string;
};

export const Anime: React.VFC<Props> = ({ type, width, height }) => {
  if (typeof window === 'undefined' || !Lottie) {
    // SSR中は空のdivを返す
    return <div style={{ width, height }} />;
  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Animes[type],
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Lottie
      options={defaultOptions}
      height={height}
      width={width}
      style={{ margin: 0 }}
    />
  );
};
